import axios from 'axios'
import Reference from '../models/reference'
import Note from '../models/note'
import Dilution from '../models/dilution'
import Substitution from '../models/substitution'
import ApplicationBinary from '../models/applicationBinary'
import Content from '../models/content'
import auth from '../services/auth'
import router from '../router'
import ReducedKidneyFunctionDrug from '../models/reducedKidneyFunctionDrug'

export const getAll = (store) => {
  let lastApiGet = sessionStorage.getItem('last_api_get')
  var outdated = false
  if (lastApiGet) {
    var lastTry = new Date(Date.parse(lastApiGet))
    lastTry = lastTry.setHours(lastTry.getHours())
    var now = new Date()
    now = now.setHours(now.getHours() - 2)
    outdated = lastTry < now
  }
  if (!lastApiGet || outdated) {
    getCrushingCommonRecommendation(store)
    getDilutions(store)
    getReferences(store)
    getNotes(store)
    getSubstitutions(store)
    // getPdf(store)
    getContents(store)
    getMiscibilitySubstances(store)
    getStorageCities(store)
    getReducedKidneyFunctionDrugs(store)
    sessionStorage.setItem('last_api_get', new Date())
  }
}

// This function is called to clear all data in the store for drugs
export const clearAll = ({ commit }) => {
  commit('get', { property: 'crushingDrugForms', crushingDrugForms: [] })
  commit('get', { property: 'eyedropDosages', eyedropDosages: [] })
  commit('get', { property: 'generalRecText', generalRecText: '' })
  commit('get', { property: 'applicationDynamicText', applicationDynamicText: '' })
  commit('get', { property: 'crushingDrugs', crushingDrugs: [] })
  commit('get', { property: 'dilutions', dilutions: [] })
  commit('get', { property: 'references', references: [] })
  commit('get', { property: 'notes', notes: [] })
  commit('get', { property: 'substitutions', substitutions: [] })
  commit('get', { property: 'pdf', pdf: {} })
  commit('get', { property: 'contents', content: [] })
  commit('get', { property: 'miscibilitySubstances', miscibilitySubstances: [] })
  commit('get', { property: 'cities', cities: [] })
  commit('get', { property: 'reducedKidneyFunctionDrugs', reducedKidneyFunctionDrugs: [] })
  // Ensure that data is reloaded
  sessionStorage.removeItem('last_api_get')
}

export const getToken = ({ commit }) => {
  axios.post('authentication/token', null, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, withCredentials: true })
    .then((result) => {
      if (result.status === 200) {
        const data = result.data
        auth.login(data)
        commit('signIn', data)
      } else {
        commit('signInError', result.status)
      }
    })
    .catch((error) => {
      sessionStorage.removeItem('last_api_get')
      commit('signInError', error.response.status)
      console.log(error)
    })
}

export const getReferences = ({ commit }) => {
  axios.get('references')
    .then((result) => {
      let references = []
      result.data.forEach((item) => {
        references.push(new Reference(item.id, item.name, item.text))
      })

      commit('get', { property: 'references', references })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getNotes = ({ commit }) => {
  axios.get('notes')
    .then((result) => {
      let notes = []
      result.data.forEach((item) => {
        notes.push(new Note(item.id, item.name, item.text))
      })

      commit('get', { property: 'notes', notes })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getDilutions = ({ commit }) => {
  axios.get('dilutions')
    .then((result) => {
      let dilutions = []
      result.data.forEach((item) => {
        dilutions.push(new Dilution(item.id, item.name, item.substance, item.dosageForm, item.remark,
                                    item.dilutionInfos, item.modifiedDate, item.modifiedByHsaId, item.modifiedByName,
                                    item.isPublished))
      })

      commit('get', { property: 'dilutions', dilutions })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const createDilution = ({ commit }, dilutionName) => {
  axios.post('dilutions', { name: dilutionName })
    .then((result) => {
      commit('createDilution', result.data)
      router.push('/spadning/' + result.data.id)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteDilution = ({ commit }, dilution) => {
  axios.delete('dilutions/' + dilution.id)
    .then(() => {
      commit('deleteDilution', dilution)
      router.push('/spadning')
    })
    .catch((error) => {
      console.log(error)
    })
}

export const updateDilution = ({ commit }, dilution) => {
  axios.put('dilutions/' + dilution.id, dilution)
    .then(() => {
      commit('updateDilution', dilution)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getVersionInfo = ({ commit }) => {
  axios.get('getVersionInfo')
    .then((result) => {
      let version = result.data || {}
      commit('setVersionInfo', version)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getStaticText = ({ commit }, textKey) => {
  axios.get('getStaticTextByKey', { params: { textKey } })
    .then((result) => {
      let text = result.data || ''
      commit('setStaticText', {text, textKey})
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getStorageUpdateDate = ({ commit }) => {
  axios.get('storage/getStorageLatestUpdateTime')
    .then((result) => {
      let dates = result.data || {}
      commit('setStorageLatestUpdateTime', dates)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getEyedropDosages = ({ commit }) => {
  axios.get('eyedrops/getNormalDoseList')
    .then((result) => {
      let dosages = result.data || []
      commit('setEyedropDosages', dosages)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getEyedropCommonRecommendation = ({commit}) => {
  axios.get('eyedrops/getCommonRecommendation')
    .then((result) => {
      if (result.data) {
        const generalRec = { text: result.data.recommendationTextWebApp, changeDate: result.data.changeDate }
        commit('setEyedropGeneralRecommendation', generalRec)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getCrushingDrugForms = ({ commit }) => {
  axios.get('crushingapi/getCrushingDrugForms')
    .then((result) => {
      let drugForms = result.data || []
      commit('setCrushingDrugForms', drugForms)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getCrushingCommonRecommendation = ({commit}) => {
  axios.get('crushingapi/getCrushingCommonRecommendation')
    .then((result) => {
      if (result.data) {
        const generalRecText = result.data.recommendationTextWebApp || ''
        commit('setGeneralRecText', generalRecText)
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getApplicationDynamicTextByKey = ({commit}, recordKey) => {
  axios.get('application/getDynamicTextByKey', { params: { recordKey } })
    .then((result) => {
      if (result.data) {
        let textObj = result.data || ''
        commit('setApplicationDynamicText', {textObj, recordKey})
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getBinaryPromise = (recordKey) => {
  const binary = new ApplicationBinary()
  binary.entryKey = recordKey

  return axios.get('application/getBinaryByKey', { params: { recordKey } }).then(result => {
    binary.base64Representation = result.data ? result.data.fileContents : ''

    axios.get('application/getBinaryMetadataByKey', { params: { recordKey } }).then(result => {
      binary.changedBy = result.changedBy
      binary.changedDate = result.changeDate
    })
    .catch((error) => {
      console.log(error)
      throw error
    })

    return binary
  })
  .catch((error) => {
    console.log(error)
    throw error
  })
}

export const getPdf = ({ commit }, recordKey) => {
  return getBinaryPromise(recordKey).then(result => {
    commit('setPdf', result)
  })
  .catch((error) => {
    console.log(error)
  })
}

export const getSubstitutions = ({ commit }) => {
  axios.get('substitutions')
    .then((result) => {
      let substitutions = []
      result.data.forEach((item) => {
        substitutions.push(new Substitution(item.id, item.drugFrom, item.drugTo, item.category, item.subCategory,
                                            item.isNew, item.isProcured, item.isChangedByLogistikCentrum,
                                            item.modifiedDate, item.modifiedByHsaId, item.modifiedByName, item.isPublished,
                                            item.nplIdFrom, item.nplIdTo))
      })
      commit('get', { property: 'substitutions', substitutions })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const createSubstitution = ({ commit }, substitution) => {
  return new Promise((resolve, reject) => {
    axios.post('substitutions', substitution)
      .then((result) => {
        commit('createSubstitution', result.data)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const deleteSubstitution = ({ commit }, substitution) => {
  return new Promise((resolve, reject) => {
    axios.delete('substitutions/' + substitution.id)
      .then(() => {
        commit('deleteSubstitution', substitution)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const updateSubstitution = ({ commit }, substitution) => {
  return new Promise((resolve, reject) => {
    axios.put('substitutions/' + substitution.id, substitution)
      .then(() => {
        commit('updateSubstitution', substitution)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const createNote = ({ commit }, note) => {
  return new Promise((resolve, reject) => {
    axios.post('notes', note)
      .then((result) => {
        commit('createNote', result.data)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const deleteNote = ({ commit }, note) => {
  return new Promise((resolve, reject) => {
    axios.delete('notes/' + note.id)
      .then(() => {
        commit('deleteNote', note)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const updateNote = ({ commit }, note) => {
  return new Promise((resolve, reject) => {
    axios.put('notes/' + note.id, note)
      .then(() => {
        commit('updateNote', note)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const createReference = ({ commit }, reference) => {
  return new Promise((resolve, reject) => {
    axios.post('references', reference)
      .then((result) => {
        commit('createReference', result.data)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const deleteReference = ({ commit }, reference) => {
  return new Promise((resolve, reject) => {
    axios.delete('references/' + reference.id)
      .then(() => {
        commit('deleteReference', reference)
        resolve(true)
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const updateReference = ({ commit }, reference) => {
  return new Promise((resolve, reject) => {
    axios.put('references/' + reference.id, reference)
      .then((result) => {
        if (result.status === 200) {
          commit('updateReference', reference)
          resolve(true)
        } else {
          reject(result.message)
        }
      })
      .catch((error) => {
        console.log(error)
        reject(error)
      })
  })
}

export const getContents = ({ commit }) => {
  axios.get('contents')
    .then((result) => {
      let contents = []
      result.data.forEach((item) => {
        contents.push(new Content(item.id, item.key, item.text))
      })
      commit('get', { property: 'contents', contents })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const updateContent = ({ commit }, content) => {
  axios.put('contents/' + content.id, content)
    .then(() => {
      commit('updateContent', content)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getMiscibilitySubstances = ({ commit }) => {
  axios.get('miscibility/substances')
    .then((result) => {
      let miscibilitySubstances = result.data
      commit('get', { property: 'miscibilitySubstances', miscibilitySubstances })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const getAssessments = (assessments) => {
  return axios.post('miscibility/assessments', assessments)
}

export const getStorageItems = (search, cities, longitude, latitude) => {
  return axios.get('storage/storageitems/' + search + '/' + cities + '/' + longitude + '/' + latitude)
}

export const getStorageCities = ({ commit }) => {
  axios.get('storage/cities')
    .then((result) => {
      let cities = result.data
      commit('get', { property: 'cities', cities })
    })
}

export const getDeliveryItems = (search, cities, longitude, latitude) => {
  return axios.get('storage/deliveries/' + search + '/' + cities + '/' + longitude + '/' + latitude)
}

export const getReducedKidneyFunctionDrugs = ({ commit }) => {
  axios.get('reducedkidneyfunction')
    .then((result) => {
      let reducedKidneyFunctionDrugs = []
      result.data.forEach((item) => {
        reducedKidneyFunctionDrugs.push(new ReducedKidneyFunctionDrug(item.id, item.name, item.substance, item.modifiedDate,
          item.modifiedByHsaId, item.modifiedByName, item.isPublished, item.nplId, item.fass, item.theRenalDrugHandbook,
          item.theKidney, item.theClinicalUseOfDrugs, item.drugdex, item.martindale, item.geriatricDosageHandbook, item.other))
      })
      commit('get', { property: 'reducedKidneyFunctionDrugs', reducedKidneyFunctionDrugs })
    })
    .catch((error) => {
      console.log(error)
    })
}

export const createReducedKidneyFunctionDrug = ({ commit }, drugName) => {
  axios.post('reducedkidneyfunction', { name: drugName })
    .then((result) => {
      commit('createReducedKidneyFunctionDrug', result.data)
      router.push('/nedsattnjurfunktion/' + result.data.id)
      // redirect to edit
    })
    .catch((error) => {
      console.log(error)
    })
}

export const updateReducedKidneyFunctionDrug = ({ commit }, drug) => {
  axios.put('reducedkidneyfunction/' + drug.id, drug)
    .then(() => {
      commit('updateReducedKidneyFunctionDrug', drug)
    })
    .catch((error) => {
      console.log(error)
    })
}

export const deleteReducedKidneyFunctionDrug = ({ commit }, drug) => {
  axios.delete('reducedkidneyfunction/' + drug.id, drug)
    .then(() => {
      commit('deleteReducedKidneyFunctionDrug', drug)
      router.push('/nedsattnjurfunktion')
    })
    .catch((error) => {
      console.log(error)
    })
}

export default {
  getToken,
  getNotes,
  getDilutions,
  createDilution,
  deleteDilution,
  updateDilution,
  createSubstitution,
  deleteSubstitution,
  updateSubstitution,
  updateContent,
  createReducedKidneyFunctionDrug,
  updateReducedKidneyFunctionDrug,
  deleteReducedKidneyFunctionDrug
}
